var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-t m-b"},[_c('div',{staticClass:"line-height-15"},[_vm._v(_vm._s(_vm.date))]),_c('div',{staticClass:"line-height-15 font-color-lighter font-sm"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }